import React, { useContext, useEffect, useState } from 'react'
import agentStyle from '../../Styles/ComponentStyles/Agent.module.scss'
import globalStyle from '../../Styles/ComponentStyles/global.module.scss'
import { Button, Fade, FormControlLabel, FormGroup, Grid, Menu, MenuItem, Stack, styled, Switch } from '@mui/material'
import GlobalBadgesCard from '../../GlobalComponent/GlobalBadgesCard/GlobalBadgesCard'
import { AgentContext, AgentContextPayload } from '../../Context/AgentDetailsContext'

import admin from '../../assets/Images/Agent/Admins.svg'
import activeAgent from '../../assets/Images/Agent/Active Agent.svg'
import inaciveAgent from '../../assets/Images/Agent/Inactive Agent.svg'

import moment from 'moment'
import { DataGrid, GridToolbar, GridToolbarContainer, GridValueGetterParams } from '@mui/x-data-grid'
import { useSnackbar } from '../../GlobalComponent/GlobalSnackbar/GlobalSnackbar'
import { UserContext, UserContextPayload } from '../../Context/UserDetailContext'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import GlobalPopUp from '../../GlobalComponent/GlobalPopup/GlobalPopup'
import RegisterAgent from '../../GlobalComponent/RegisterAgent/RegisterAgent'
import agent from '../../service/api'
import GlobalDeletePopup from '../../GlobalComponent/GlobalDeletePopup/GlobalDeletePopup'
import CustomPagination from '../../GlobalComponent/CustomPagination/CustomPagination';


const IOSSwitch = styled((props: any) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 36,
    height: 20,
    padding: 0,
    margin: "5px !important",
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: "2px !important",
        transitionDuration: '300ms',
        top: '0px',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.mode === 'dark' ? '#3B78CE' : '#3B78CE',
                opacity: 1,
                border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color:
                theme.palette.mode === 'light'
                    ? theme.palette.grey[100]
                    : theme.palette.grey[600],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
        },

    },
    '& .MuiFormControlLabel-root': {
        marginLeft: '0px !important'
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 15,
        height: 15,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
    }
}));


const Agent = () => {

    const {
        agentDetails,
        setAgentDetails,
        getAgentDetails,
        setAgentGlobalDetails,
        getAgentStatusDetails,
        setAgentStatusDetails,

        agentStatusStoredCurrentName,
        setAgentStatusStoredCurrentName,

        setAgentGlobalDetailsForTable,
        agentGlobalDetailsForTable,

        removeAgentId,
        setRemoveAgentId,
        agentFormDetails,
        setagentFormDetails,

        flagOpenAgentDetailsDialog,
        setFlagOpenAgentDetailsDialog,
        isEditMode,
        setIsEditMode
    } = useContext(AgentContext) as AgentContextPayload

    const {
        setFlagLoader,
        userDetail
    } = useContext(UserContext) as UserContextPayload

    const { showSnackbar } = useSnackbar();

    const [counts, setCounts] = useState<any>({
        totalAdmins: 0,
        totalActiveAgents: 0,
        totalPendingAgents: 0,
        totalInactiveAgents: 0
    });
    const [open, setOpen] = React.useState({
        status: false,
        id: 0,
    });
    const [selectedAgent, setSelectedAgent] = React.useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMenu = Boolean(anchorEl);
    const [flagOpenAgentDeleteDialog, setFlagOpenAgentDeleteDialog] = useState<boolean>(false);

    const cards = [
        { icons: admin, headText: "Admins", count: counts.totalAdmins },
        { icons: activeAgent, headText: "Active Agents", count: counts.totalActiveAgents },
        // { icons: pendingAgent, headText: "Pending Agents", count: counts.totalPendingAgents },
        { icons: inaciveAgent, headText: "Inactive Agents", count: counts.totalInactiveAgents },
    ];

    const columns: any = [
        // {
        //     field: 'admin_user_id',
        //     headerName: 'Agent Id',
        //     align: 'left',
        //     headerAlign: 'left',
        //     flex: 1,
        //     hide: true,
        //     width: 80,
        // },
        {
            field: 'user_firstname',
            headerName: 'FIRST NAME',
            align: 'left',
            headerAlign: 'left',
            flex: 1,
            width: 180,
            minWidth: 180,
            renderCell: (params: any) => {
                let paramsDetails = params.row
                return (
                    <>
                        <Grid item>
                            <span>{paramsDetails.user_firstname}</span>
                            {params.row.user_role_type.toLowerCase() == "admin" &&
                                <span
                                    style={{
                                        background: "#1D2B84",
                                        padding: '2px 8px',
                                        borderRadius: "5px",
                                        color: '#ffffff',
                                        marginLeft: '10px',
                                        fontSize: '11px'
                                    }}
                                >
                                    Admin
                                </span>
                            }
                        </Grid>
                    </>
                )
            }
        },
        {
            field: 'user_lastname',
            headerName: 'LAST NAME',
            align: 'left',
            headerAlign: 'left',
            flex: 1,
            width: 180,
            minWidth: 180,
        },
        {
            field: 'user_created_at',
            headerName: 'CREATED DATE',
            valueGetter: (params: GridValueGetterParams) => moment(params?.row?.user_created_at)?.format("MM/DD/YYYY  hh:mm A"),
            align: 'left',
            headerAlign: 'left',
            flex: 1,
            width: 180,
            minWidth: 180,
        },
        {
            field: 'user_email',
            headerName: 'EMAIL',
            align: 'left',
            headerAlign: 'left',
            flex: 2,
            width: 300,
            minWidth: 300,
        },
        {
            field: 'user_contact',
            headerName: 'CONTACT',
            align: 'left',
            headerAlign: 'left',
            flex: 1,
            width: 140,
            minWidth: 140,
        },
        {
            field: 'user_recent_login_timestamp',
            headerName: 'RECENT LOGIN',
            valueGetter: (params: GridValueGetterParams) => params?.row?.user_recent_login_timestamp ? moment(params?.row?.user_recent_login_timestamp)?.format("MM/DD/YYYY  hh:mm A") : "",
            align: 'left',
            headerAlign: 'left',
            flex: 1.2,
            minWidth: 180,
            width: 180,
        },
        {
            field: "total_assigned_profile_count",
            headerName: "PROFILES",
            align: 'left',
            headerAlign: 'left',
            minWidth: 100,
            width: 100,
            flex: 0.8,
        },
        {
            field: 'user_status_id',
            headerName: 'STATUS',
            align: 'left',
            headerAlign: 'left',
            flex: 0.5,
            minWidth: 100,
            width: 100,
            renderCell: (params: any) => {
                let rowData = params.row
                let userRoleType = rowData.user_role_type
                let userStatusName = rowData.user_status_name
                let userStatusId = rowData.user_status_name.toLowerCase()
                return (
                    <>
                        <FormGroup className={`${agentStyle.agentStatusSwitch}`}>
                            {userStatusName.toLowerCase() != "registered" && userRoleType?.toLowerCase() != "admin" &&
                                <FormControlLabel
                                    label=""
                                    sx={{
                                        "& .MuiFormControlLabel-root ": {
                                            marginLeft: "0px !important"
                                        }
                                    }}
                                    control={
                                        <IOSSwitch
                                            checked={userStatusId == agentStatusStoredCurrentName?.toLowerCase()}
                                            onChange={(e: any) => { ChangeStatus(e, rowData) }}
                                        />
                                    }
                                />
                            }
                        </FormGroup>
                    </>
                )
            }
        },
        {
            field: '',
            headerName: '',
            align: 'left',
            headerAlign: 'left',
            sortable: false,
            disableColumnMenu: true,
            flex: 0.5,
            minWidth: 80,
            width: 80,
            renderCell: (params: any) => {
                let row = params.row

                return (
                    <>
                        {row.user_role_type.toLowerCase() !== "admin" &&
                            <>
                                <Button
                                    id="fade-button"
                                    aria-controls={open ? 'fade-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    onClick={(e) => {
                                        setRemoveAgentId(row.user_id)
                                        handleOpenAgentMenu(e)
                                        handleEditAgent(row);
                                    }}
                                >
                                    <MoreVertIcon
                                        sx={{
                                            color: '#666666 !important',
                                            '&:hover': {
                                                backgroundColor: 'rgba(255, 255, 255, 0.3)',
                                                borderRadius: '5px'
                                            }
                                        }}
                                    />
                                </Button>

                                <Menu
                                    id="fade-menu"
                                    MenuListProps={{ 'aria-labelledby': 'fade-button', }}
                                    anchorEl={anchorEl}
                                    open={openMenu}
                                    onClose={handleCloseAgentMenu}
                                    TransitionComponent={Fade}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                    PaperProps={{
                                        style: {
                                            boxShadow: "0px 0px 1px 0px #00000033",
                                            background: "#FFFFFF"
                                        },
                                    }}
                                >
                                    <MenuItem
                                        sx={{
                                            color: '#000000',
                                            '&:hover': {
                                                backgroundColor: 'white',
                                                color: '#105EA7',
                                            }
                                        }}
                                        onClick={() => {
                                            // handleEditAgent(row);
                                            setFlagOpenAgentDetailsDialog(true);
                                            setAnchorEl(null);
                                        }}
                                    >
                                        <ModeEditOutlineOutlinedIcon fontSize="small" />&nbsp;<span>Edit</span>
                                    </MenuItem>

                                    <MenuItem
                                        sx={{
                                            color: '#000000',
                                            '&:hover': {
                                                backgroundColor: 'white',
                                                color: '#105EA7',
                                            }
                                        }}
                                        onClick={() => {
                                            setagentFormDetails({})
                                            setAnchorEl(null);
                                            setFlagOpenAgentDeleteDialog(true);
                                        }}
                                    >
                                        <DeleteForeverOutlinedIcon fontSize="small" />
                                        &nbsp;
                                        <span>Delete</span>
                                    </MenuItem>
                                </Menu>
                            </>
                        }
                    </>
                )
            }
        },
    ];

    useEffect(() => {
        (async () => {
            setFlagLoader(true)
            const response = await getAgentDetails()
            if (response?.status) {
                if (response?.data) {

                    const agentData = response.data[0].agents?.map((row) => {
                        if (row.user_role_type.toLowerCase() !== "admin" && row.user_status_name.toLowerCase() === "registered") {
                            return { ...row, pending: true };
                        }
                        else {
                            return { ...row, pending: false };
                        }
                    })
                    const agentGlobalData = response.data
                    const agentFilterData = agentData?.filter((filterStatus) => filterStatus.user_status_name.toLowerCase() !== "delete");
                    setAgentGlobalDetails(agentGlobalData)
                    setAgentDetails(agentFilterData)
                    setAgentGlobalDetailsForTable(agentData)
                    setCounts({
                        totalAdmins: agentGlobalData[0]?.total_admin_count,
                        totalActiveAgents: agentGlobalData[0]?.total_active_agent_count,
                        totalPendingAgents: agentGlobalData[0]?.total_pending_agent_count,
                        totalInactiveAgents: agentGlobalData[0]?.total_inactive_agent_count
                    });
                }
                const agentStatusResponse = await getAgentStatusDetails()
                if (agentStatusResponse.status && agentStatusResponse.data) {
                    setAgentStatusDetails(agentStatusResponse.data)
                    const activeStatus = agentStatusResponse?.data?.find((status) => status.status_name.toLowerCase() === "active");

                    if (activeStatus) {
                        let activeStatusName = activeStatus.status_name
                        setAgentStatusStoredCurrentName(activeStatusName)
                    }
                    else {
                        console.log('Active status not found');
                    }
                }
                else {
                    const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
                    showSnackbar(errorMessage, 'error');
                }
                setFlagLoader(false)
            }
            else {
                setAgentStatusStoredCurrentName("active")
                setFlagLoader(false)
                const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
                showSnackbar(errorMessage, 'error');
            }
        })();
    }, [])

    const handleOpenAgentMenu = (event: any) => {
        setAnchorEl(event.currentTarget);
    }

    const handleCloseAgentMenu = (event: any) => {
        setAnchorEl(null);
    }

    function NoRowsOverlay() {
        return (
            <Stack sx={{ justifyContent: 'center', height: '100%', alignItems: 'center', color: '#0F172B' }}>
                No Data Found
            </Stack>
        );
    }

    const CustomToolbar = () => {
        return (
            <GridToolbarContainer
                sx={{
                    margin: '5px 0px 25px',
                    float: 'right',
                    '& .MuiButtonBase-root': {
                        color: '#ffffff !important',
                    },
                }}
            >
                <GridToolbar />
            </GridToolbarContainer>
        );
    };

    const refreshAgentListAndStatus = async (
        isPendingRow: (row: any) => boolean,
        keepInAgentDetails: (row: any) => boolean
    ) => {
        const response = await getAgentDetails();
        if (response?.status) {
            if (response?.data) {
                const agentData = response.data[0].agents?.map((row: any) => {
                    if (isPendingRow(row)) {
                        return { ...row, pending: true };
                    }
                    else {
                        return { ...row, pending: false };
                    }
                })
                const agentGlobalData = response.data
                const agentFilterData = agentData?.filter(keepInAgentDetails);

                setAgentGlobalDetails(agentGlobalData)
                setAgentDetails(agentFilterData)
                setAgentGlobalDetailsForTable(agentData)
                setCounts({
                    totalAdmins: agentGlobalData[0]?.total_admin_count,
                    totalActiveAgents: agentGlobalData[0]?.total_active_agent_count,
                    totalPendingAgents: agentGlobalData[0]?.total_pending_agent_count,
                    totalInactiveAgents: agentGlobalData[0]?.total_inactive_agent_count
                });
            }
            const agentStatusResponse = await getAgentStatusDetails()
            if (agentStatusResponse.status && agentStatusResponse.data) {
                setAgentStatusDetails(agentStatusResponse.data)
                const activeStatus = agentStatusResponse?.data?.find((status) => status.status_name.toLowerCase() == "active");
                if (activeStatus) {
                    let activeStatusName = activeStatus.status_name;
                    setAgentStatusStoredCurrentName(activeStatusName)
                }
                else {
                    console.log('Active status not found');
                }
            }
            else {
                const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
                showSnackbar(errorMessage, 'error');
            }
            setFlagLoader(false)
        }
        else {
            setAgentStatusStoredCurrentName("active")
            setFlagLoader(false)
            const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
        }
    };

    const handleRemoveAgent = async (agent_id: any) => {
        setFlagLoader(true)
        const response = await agent.removeAgentAPI.delete(agent_id)
        if (response?.status) {
            await refreshAgentListAndStatus(
                (row: any) => row.user_role_type.toLowerCase() != "admin" && row.user_status_name.toLowerCase() == "registered",
                (filterStatus: any) => filterStatus.user_status_name.toLowerCase() != "delete"
            );
            setFlagOpenAgentDeleteDialog(false)
        }
        else {
            setFlagOpenAgentDeleteDialog(false)
            const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
        }
    }


    const handleEditAgent = (agent: any) => {
        setSelectedAgent(agent);
        setagentFormDetails({
            first_name: agent.user_firstname,
            last_name: agent.user_lastname,
            email_address: agent.user_email,
            contact_number: agent.user_contact,
            re_captcha: "",
        });
        setIsEditMode(true);
    };

    const handleRegisterSubmit = async (agentData: any) => {
        try {
            const registrationData = {
                ...agentData,
                re_captcha: agentData.captcha === "" ? "123" : agentData.captcha,
                created_by_admin_flag: true,
                admin_user_id: userDetail?.user_data?.user_id,
                agent_licensed_checkbox: true,
                user_agreement_checkbox: false,
            };
            setFlagLoader(true)
            const { agency_id, ...registerData } = registrationData;
            const response = await agent.agentRegisterAPI.post(registerData);
            if (response?.status) {
                showSnackbar("Agent registered successfully!", 'success');
                setFlagOpenAgentDetailsDialog(false);

                await refreshAgentListAndStatus(
                    (row: any) => row.user_role_type.toLowerCase() != "admin" && row.user_status_name.toLowerCase() == "registered",
                    (filterStatus: any) => filterStatus.user_status_name.toLowerCase() == "delete"
                );
            } else {
                // showSnackbar("Failed to register agent!", 'error');
                setFlagLoader(false)
                const errorMessage = response?.error?.message || 'Something Went Wrong!';
                showSnackbar(errorMessage, 'error');
            }
            setFlagLoader(false)
        }
        catch (error) {
            console.error("Error registering agent:", error);
            setFlagLoader(false)
        }
    };

    const handleEditSubmit = async (agentData: any) => {
        try {
            setFlagLoader(true);

            const updateData = {
                agent_id: removeAgentId,
                firstname: agentData.first_name,
                lastname: agentData.last_name,
                email: agentData.email_address,
                contact: agentData.contact_number,
            };

            const response = await agent.updateAgentRegisterAPI.put(updateData);
            if (response?.status) {
                showSnackbar("Agent updated successfully!", 'success');
                setFlagOpenAgentDetailsDialog(false);
                setFlagLoader(false);

                await refreshAgentListAndStatus(
                    (row: any) => row.user_role_type.toLowerCase() != "admin" && row.user_status_name.toLowerCase() === "registered",
                    (filterStatus: any) => filterStatus.user_status_name.toLowerCase() !== "delete"
                );
            } else {
                showSnackbar("Failed to update agent!", 'error');
                setFlagLoader(false);
            }
        } catch (error) {
            console.error("Error updating agent:", error);
            showSnackbar("Something went wrong!", 'error');
            setFlagLoader(false);
        }
    };

    const ChangeStatus = async (e: any, row: any) => {
        try {
            setFlagLoader(true)

            const changeStatusPayload = {
                agent_id: row?.user_id,
                agent_active_flag: e.target.checked
            }

            const response = await agent.inActiveAgentAPI.put(changeStatusPayload);
            if (response?.status) {
                await refreshAgentListAndStatus(
                    (row: any) => row?.user_role_type?.toLowerCase() !== "admin" && row?.user_status_name?.toLowerCase() === "registered",
                    (filterStatus: any) => filterStatus.user_status_name?.toLowerCase() != "delete"
                );
            } else {
                showSnackbar("Failed to update agent!", 'error');
                setFlagLoader(false);
            }
        } catch (error) {
            console.error("Error updating agent:", error);
            setFlagLoader(false);
        }
    }

    return (
        <>
            {flagOpenAgentDetailsDialog &&
                <GlobalPopUp
                    open={flagOpenAgentDetailsDialog}
                    onClose={() => { setFlagOpenAgentDetailsDialog(false) }}
                    title={isEditMode ? "Edit Agent" : "Register Agent"}
                    showCloseIcon={true}
                    flagDivider
                    maxWidth={"sm"}
                >
                    <RegisterAgent
                        setFlagOpenAgentDetailsDialog={setFlagOpenAgentDetailsDialog}
                        isEditMode={isEditMode}
                        selectedAgent={selectedAgent}
                        handleSubmit={isEditMode ? handleEditSubmit : handleRegisterSubmit}
                        agentFormDetails={agentFormDetails}
                        setagentFormDetails={setagentFormDetails}
                    />
                </GlobalPopUp>
            }

            {flagOpenAgentDeleteDialog && (
                <GlobalPopUp
                    open={flagOpenAgentDeleteDialog}
                    onClose={() => { setFlagOpenAgentDeleteDialog(false) }}
                    title="Delete Agent"
                    showCloseIcon={true}
                    flagDivider
                    maxWidth={"sm"}
                >
                    <GlobalDeletePopup
                        popupDescription="Are you sure you want to delete this Agent?"
                        handleClose={() => setFlagOpenAgentDeleteDialog(false)}
                        onDelete={() => handleRemoveAgent(removeAgentId)}
                    />
                </GlobalPopUp>
            )}

            <Grid container>
                {/* <Grid item xs={12}>
                    <GlobalNavbar
                        navbarBtnText={'New Agent'}
                        navbarBtnOnClick={() => {
                            setIsEditMode(false)
                            setFlagOpenAgentDetailsDialog(true)
                            setagentFormDetails({})
                        }}
                        navbarText={"Agents List"}
                    />
                </Grid> */}
                <Grid item xs={12} padding="20px" className={`${globalStyle.globalBlurWrapper}`}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Grid container sx={{ gap: "20px" }}>
                                {cards.map((card) => (
                                    <Grid item className={`${agentStyle.profileCardItem}`}>
                                        <GlobalBadgesCard
                                            image={card.icons}
                                            cardHeadText={card.headText}
                                            cardSubText={String(card.count)}
                                            bdgBackgroundColor="rgba(255, 255, 255, 0.3)"
                                            bdgFilter="blur(5px)"
                                            bdgBorder="1px solid #E2E8F0"
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>

                        <Grid item xs={12} className={`${agentStyle.agentTabMainWrapper}`}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <DataGrid
                                        className={`${agentStyle.agentTable}`}
                                        rows={agentGlobalDetailsForTable}
                                        columns={columns}
                                        getRowId={(agent: any) => (agent.user_id)}
                                        density="compact"
                                        hideFooterSelectedRowCount
                                        rowHeight={60}
                                        pageSize={10}
                                        rowsPerPageOptions={[5]}
                                        components={{
                                            Pagination: CustomPagination,
                                            Toolbar: CustomToolbar, NoRowsOverlay
                                        }}
                                        autoHeight
                                        sx={{
                                            borderRadius: '5px',
                                            overflow: 'hidden',
                                            "& .MuiDataGrid-columnHeaders": {
                                                backgroundColor: "#F2F6F9",
                                                color: '#45556C',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                textTransform: 'uppercase',
                                                border: 'none',
                                                minHeight: "54px !important"
                                            },
                                            "& .MuiDataGrid-columnHeaderTitleContainer": {
                                                justifyContent: "start !important"
                                            },
                                            "& .MuiDataGrid-columnHeader": {
                                                padding: '0 16px',
                                                outline: 'none !important',
                                                justifyContent: 'flex-start',
                                            },
                                            "& .MuiDataGrid-columnHeaderTitle": {
                                                fontWeight: 600,
                                                textAlign: 'left',
                                            },
                                            "& .MuiDataGrid-main": {
                                                backgroundColor: "#ffffff",
                                                borderRadius: "5px 5px 0px 0px",
                                                borderTop: "1px solid #E2E8F0",
                                                borderLeft: "1px solid #E2E8F0",
                                                borderRight: "1px solid #E2E8F0",
                                                borderBottom: "none",
                                            },
                                            "& .MuiDataGrid-row": {
                                                backgroundColor: "#ffffff",
                                                color: "#0F172B",
                                                borderBottom: '1px solid #E2E8F0 !important',
                                                '&:hover': {
                                                    backgroundColor: '#f3f4f6 !important',
                                                },
                                            },
                                            "& .MuiDataGrid-cell": {
                                                borderBottom: 'none',
                                                padding: '0 16px',
                                                fontSize: '14px !important',
                                                outline: 'none !important',
                                            },
                                            "& .MuiDataGrid-cell:focus": {
                                                outline: 'none !important',
                                            },
                                            "& .MuiDataGrid-cell:focus-within": {
                                                outline: 'none !important',
                                            },
                                            "& .MuiDataGrid-cell:hover": {
                                                cursor: "pointer",
                                            },
                                            "& .MuiDataGrid-columnSeparator": {
                                                display: 'none',
                                            },
                                            "& .MuiDataGrid-footerContainer": {
                                                borderTop: "none",
                                                borderLeft: "1px solid #E2E8F0",
                                                borderRight: "1px solid #E2E8F0",
                                                borderBottom: "1px solid #E2E8F0",
                                                backgroundColor: '#F2F6F9',
                                                minHeight: '52px',
                                                padding: '0 16px',
                                                borderRadius: "0px 0px 5px 5px"
                                            },
                                            "& .MuiTablePagination-root": {
                                                color: '#6b7280',
                                            },
                                            "& .MuiTablePagination-actions": {
                                                color: '#6b7280',
                                            },
                                            "& .MuiTablePagination-actions .MuiIconButton-root": {
                                                color: "#6b7280",
                                            },
                                            "& .MuiTablePagination-actions .MuiIconButton-root.Mui-disabled": {
                                                color: "#d1d5db",
                                            },
                                            "& .MuiTablePagination-displayedRows": {
                                                color: '#6b7280',
                                                fontSize: '14px',
                                            },
                                            "& .MuiDataGrid-toolbarContainer .MuiButtonBase-root": {
                                                color: "#525252 !important"
                                            },
                                            "& .MuiDataGrid-toolbarContainer": {
                                                margin: "5px !important"
                                            },
                                            "& .MuiDataGrid-overlay": {
                                                backgroundColor: "#ffffff",
                                            },
                                            "& .MuiDataGrid-columnHeader--moving": {
                                                backgroundColor: "transparent",
                                            },
                                            "& .MuiDataGrid-virtualScrollerContent": {
                                                marginTop: "18px"
                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default Agent